import moment from 'moment'
import React from 'react'
import DateTime from 'react-datetime'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import AdvancedTable from '../../Components/AdvancedTable'
import ProductActions from '../../Redux/ProductRedux'
import ProductVariantStocks from './ProductVariantStocks'
import ProductVariantDelete from './ProductVariantDelete'
import Toggle from 'react-toggle'

class ProductVariants extends React.Component {
  constructor (props) {
    super(props)
    this.product_id = props.detail.id
    this.title = props.detail.title
    this.dateFormat = 'YYYY-MM-DD'
    this.formLines = [
      { type: 'select', label: 'Platform', field: 'platform' },
      { type: 'datetime', label: 'Travel Start Date', field: 'start_date' },
      { type: 'datetime', label: 'Travel End Date', field: 'end_date' },
      { type: 'toggle', label: 'Use Booking Period?', field: 'use_booking_period' },
      { type: 'datetime', label: 'Booking Period Start', field: 'date_period_start' },
      { type: 'datetime', label: 'Booking Period End', field: 'date_period_end' }
    ]
    this.platforms = [
      { value: 'all', label: 'ALL' },
      { value: 'web', label: 'WEB' },
      { value: 'all-mobile', label: 'ALL-MOBILE' },
      { value: 'android', label: 'ANDROID' },
      { value: 'ios', label: 'IOS' }
    ]
    this.state = {
      form: {
        product_id: this.product_id,
        start_date: null,
        end_date: null,
        use_booking_period: 0,
        platform: 'all',
        date_period_start: null,
        date_period_end: null
      },
      bookingToggle: false,
      showModal: null,
      editMode: null,
      detail: {}
    }
  }

  componentDidMount = () => {
    this._fetchData()
  }

  _fetchData = () => {
    let data = { product_id: this.product_id }
    this.props.getProductVariant(data)
  }

  _resetForm = () => {
    let form = { ...this.state.form }
    let bookingToggle = false
    form.start_date = null
    form.end_date = null
    form.use_booking_period = 0
    form.platform = 'all'
    form.date_period_start = null
    form.date_period_end = null
    this.setState({ form, bookingToggle })
    if (this.state.editMode !== null) {
      this._forceEditMode(null, null)
    }
  }

  _handleDateTime = (date, field) => {
    let form = { ...this.state.form }
    if (field === 'start_date') {
      if (moment(date) >= moment(this.state.form.end_date)) {
        form.end_date = moment(date).add(1, 'day')
      }
    }
    if (field === 'date_period_start') {
      if (moment(date) >= moment(this.state.form.date_period_end)) {
        form.date_period_end = date
      }
    }
    form[field] = date
    this.setState({ form })
  }

  _handleToggle = (event) => {
    let form = { ...this.state.form }
    let bookingToggle = event.target.checked
    if (bookingToggle) {
      form.use_booking_period = 1
    } else if (!bookingToggle) {
      form.use_booking_period = 0
      form.date_period_start = null
      form.date_period_end = null
    }
    this.setState({ form, bookingToggle })
  }

  _handleSelectChange = (event, field) => {
    let form = { ...this.state.form }
    let value = event.target.value
    form[field] = value
    this.setState({ form })
  }

  _onSubmit = (event) => {
    if (event) event.preventDefault()
    let form = { ...this.state.form }
    form.start_date = moment(form.start_date).format(this.dateFormat)
    form.end_date = moment(form.end_date).format(this.dateFormat)
    form.date_period_start !== null ? form.date_period_start = moment(form.date_period_start).format(this.dateFormat) : form.date_period_start = null
    form.date_period_end !== null ? form.date_period_end = moment(form.date_period_end).format(this.dateFormat) : form.date_period_end = null
    if (this.state.editMode === null) {
      let data = { form }
      this.props.postProductVariant(data)
    } else if (this.state.editMode !== null) {
      let data = { form, id: this.state.detail.id }
      this.props.putProductVariant(data)
    }
    setTimeout(() => {
      this._resetForm()
    }, 300)
  }

  _selectItem = (item, modalID, editID) => {
    this.setState({ detail: item })
    if (modalID !== null) {
      this._toggleModal(modalID)
    } else if (editID !== null) {
      this._forceEditMode(item, editID)
    }
  }

  _forceEditMode = (item, editID) => {
    this.setState({ editMode: editID })
    let form = { ...this.state.form }
    if (editID) {
      form.start_date = item.start_date
      form.end_date = item.end_date
      form.use_booking_period = item.use_booking_period
      item.use_booking_period === 1 &&
        item.date_period_start
        ? form.date_period_start = item.date_period_start
        : form.date_period_start = null
      item.use_booking_period === 1 &&
        item.date_period_end
        ? form.date_period_end = item.date_period_end
        : form.date_period_end = null
      form.platform = item.platform
      this.setState({ form, bookingToggle: item.use_booking_period === 1 })
    }
    if (!editID) {
      form.start_date = null
      form.end_date = null
      form.use_booking_period = 0
      form.platform = 'all'
      form.date_period_start = null
      form.date_period_end = null
      this.setState({ form, bookingToggle: false })
    }
  }

  _toggleModal = (modalID = null) => {
    this.setState({ showModal: modalID })
  }

  _renderHeader = (data, title, small) => {
    return (
      <React.Fragment>
        <header className='title-block'>
          <h1 className='title'>
            { title }
            {
              (data.fetching || data.processing) &&
              <div className='badge badge-info ml-2'>
                {
                  data.fetching
                    ? 'Loading ...'
                    : data.processing
                      ? 'Processing ...'
                      : ''
                }
              </div>
            }
          </h1>
          <small>{small}</small>
        </header>
        { data.err && <div className='alert alert-danger'>{data.err}</div> }
      </React.Fragment>
    )
  }

  _renderTable = (variant) => {
    return (
      <AdvancedTable
        colSpan={8}
        header={[
          { field: 'Platform' },
          { field: 'Travel Start Date' },
          { field: 'Travel End Date' },
          { field: 'Booking Period Start' },
          { field: 'Booking Period End' },
          { field: 'Stock' },
          { field: 'Edit' },
          { field: 'Delete' }
        ]}
        body={
          variant &&
          variant.length > 0 &&
          variant.map((item) => ([
            { field: item.platform },
            { field: item.start_date },
            { field: item.end_date },
            { field: item.date_period_start || '-' },
            { field: item.date_period_end || '-' },
            { field: <button
              className={`btn btn-info ${item.product_variant_stocks.length > 0 ? '' : 'boolean-red-badge'}`}
              data-badge
              disabled={this.state.editMode !== null}
              onClick={() => this._selectItem(item, 'product-variant-stocks-modal', null)}
            >
              <i className='fa fa-list mr-2' />Manage
            </button>
            },
            { field: <button
              className='btn btn-primary'
              disabled={this.state.editMode !== null}
              onClick={() => this._selectItem(item, null, item.id)}
            >
              <i className='fa fa-edit' />
            </button>
            },
            { field: <button
              className='btn btn-danger'
              disabled={this.state.editMode !== null}
              onClick={() => this._selectItem(item, 'delete-modal', null)}
            >
              <i className='fa fa-trash' />
            </button>
            }
          ]))
        }
      />
    )
  }

  _renderSubTable = (PRODUCT_VARIANT_STOCKS) => {
    return (
      <ul>
        {
          PRODUCT_VARIANT_STOCKS.map((item, i) => (
            <li key={i}>qty: {item.qty} price: {item.price}</li>
          ))
        }
      </ul>
    )
  }

  _renderForm = (formLines) => {
    return (
      <form className='mb-3' onSubmit={(event) => this._onSubmit(event)}>
        {
          formLines.map((lines, i) => this._renderFormLine(i, lines.field, lines.label, lines.type))
        }
        <div className='row'>
          <div className='col-9 text-right'>
            {
              this.state.editMode !== null &&
              <button
                className='btn btn-secondary mr-2'
                type='button'
                onClick={() => this._forceEditMode(null, null)}
              >
                <i className='fa fa-times' /> Cancel
              </button>
            }
            {
              this.state.editMode !== null
                ? <button className='btn btn-primary' type='submit'><i className='fa fa-save' /> Save</button>
                : <button className='btn btn-primary' type='submit'><i className='fa fa-plus' /> Add</button>

            }
          </div>
        </div>
      </form>
    )
  }

  _renderFormLine = (i, field, label, type) => {
    let beforeDate = null
    let today = moment()
    let yesterday = moment().subtract(1, 'day')
    if (field === 'end_date') {
      beforeDate = this.state.form.start_date
    } else if (field === 'date_period_end') {
      beforeDate = this.state.form.date_period_start
    }
    return (
      <div key={i} className='form-group'>
        <div className='row'>
          <div className='col-3'>
            <label className='control-label'>{label}</label>
          </div>
          {
            type === 'datetime' &&
              <div className='col-6'>
                <DateTime
                  value={this.state.form[field]}
                  inputProps={{
                    placeholder: `Select ${label} ...`,
                    disabled: (field === 'date_period_start' || field === 'date_period_end') && !this.state.bookingToggle
                  }}
                  closeOnSelect
                  dateFormat={this.dateFormat}
                  isValidDate={
                    field === 'start_date'
                      ? current => current.isAfter(today)
                      : field === 'date_period_start'
                        ? current => current.isAfter(yesterday)
                        : field === 'date_period_end'
                          ? current => current.isSameOrAfter(beforeDate)
                          : current => current.isAfter(beforeDate)
                  }
                  timeFormat={false}
                  onChange={(date) => this._handleDateTime(date, field)}
                />
              </div>
          }
          {
            type === 'toggle' &&
              <div className='col-6'>
                <Toggle checked={this.state.bookingToggle} onChange={(event) => this._handleToggle(event)} />
              </div>
          }
          {
            type === 'select' &&
              <div className='col-6'>
                <select value={this.state.form[field]} onChange={(event) => this._handleSelectChange(event, field)} className='form-control'>
                  {
                    this.platforms.map((item, i) => (
                      <option key={i} value={item.value}>{item.label}</option>
                    ))
                  }
                </select>
              </div>
          }
        </div>
      </div>
    )
  }

  render () {
    const { product } = this.props
    const { variant } = product
    return (
      <section className='section' style={{ width: '70vw', height: '80vh' }}>
        { this._renderHeader(product, 'Manage Dynamic Price', this.title) }
        { this._renderForm(this.formLines) }
        { this._renderTable(variant) }
        <ModalBase
          {...this.props}
          detail={this.state.detail}
          showModal={this.state.showModal}
          closeModal={() => this._toggleModal(null)}
        />
      </section>
    )
  }
}

class ModalBase extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }
  render () {
    return (
      <React.Fragment>
        <Modal
          center
          onClose={() => this.props.closeModal()}
          open={this.props.showModal === 'delete-modal'}
          classNames={{ modal: 'modal-large' }}
        >
          <ProductVariantDelete {...this.props} detail={this.props.detail} />
        </Modal>
        <Modal
          center
          onClose={() => this.props.closeModal()}
          open={this.props.showModal === 'product-variant-stocks-modal'}
          classNames={{ modal: 'modal-large' }}
        >
          <ProductVariantStocks {...this.props} detail={this.props.detail} />
        </Modal>
      </React.Fragment>
    )
  }
}

const stateToProps = (state) => ({
  product: state.product
})

const dispatchToProps = (dispatch) => ({
  getProductVariant: (data) => dispatch(ProductActions.getProductVariantRequest(data)),
  postProductVariant: (data) => dispatch(ProductActions.postProductVariantRequest(data)),
  putProductVariant: (data) => dispatch(ProductActions.putProductVariantRequest(data)),
  deleteProductVariant: (data) => dispatch(ProductActions.deleteProductVariantRequest(data)),
  getProductVariantItem: (data) => dispatch(ProductActions.getProductVariantItemRequest(data)),
  postProductVariantItem: (data) => dispatch(ProductActions.postProductVariantItemRequest(data)),
  deleteProductVariantItem: (data) => dispatch(ProductActions.deleteProductVariantItemRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ProductVariants)



// WEBPACK FOOTER //
// ./src/Containers/Product/ProductVariants.js